// import React from "react";
import { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQueryClient, useMutation } from '@tanstack/react-query';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";

import { TextField, Autocomplete } from "@mui/material";

// import UserAlerts from "../../components/UserAlerts";
// import { UserContext } from "../../App";
import NumberFormat from "react-number-format";

// import Loading from "../../components/Loading";
// import useEbayToken from "../ebay/useEbayToken";
import CustomSwitch from "../../components/CustomSwitch";


const ItemEdit = ({item, setError}) => {
    const params = useParams()
    const queryClient = useQueryClient();

    // const page_size = useContext(UserContext);
    // const {response, error, loading, fetchData}  = useAxios();

    //GET EBAY ACCESS TOKEN FOR LISTING FEATURE
    // const { ebayAccessToken, refreshEbayToken } = useEbayToken();
    // const ebayAccessToken = 'v^1.1#i^1#r^0#f^0#p^3#I^3#t^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'
 
    // const { data: inventoryTypes } = useAxios({
    //     url: '/inventory/inventory-types',
    //     method: 'get'
    // })

    //  // FETCH ACCOUNT TYPES
    //  const { data: accounttypes } = useAxios({
    //     url: '/accounting/account-types',
    //     method: 'get'
    // })

    // FETCH ACCOUNTS
    // const [accounts, setAccounts] = useState([]);
    // const [expAccounts, setExpAccounts] = useState([]);
    // const [inventoryAccounts, setInventoryAccounts] = useState([]);


    // const { data: accountsData } = useAxios({
    //     url: `/accounting/accounts?page_size=${page_size}`,
    //     method: 'get'
    // })


    const navigate = useNavigate();

    const [sku, setSku] = useState(item.sku);
    const [name, setName] = useState(item.name);
    const [rate, setRate] = useState(item.price);
    const [costInput, setCostInput] = useState(item.cost);
    // const [upc, setUpc] = useState(item.upc);
    const [type, setType] = useState(item.type);
    const [memo, setMemo] = useState(item.memo);
    // const [tax, setTax] = useState([]);
    const [quantity, setQuantity] = useState(item.quantity);
    const [reorderLevel, setReorderLevel] = useState(item.reorder_level);
    const [checked, setChecked] = useState(item.has_variants);



    const [inventoryType, setInventoryType] = useState('');
    // const [type, setType] = useState('');
    const [revenueAccount, setRevenueAccount] = useState('');
    const [expenseAccount, setExpenseAccount] = useState('');
    const [inventoryAccount, setInventoryAccount] = useState('');


    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');

    // const [categoryError, setCategoryError] = useState(false)
    const [inventoryTypeError, setInventoryTypeError] = useState(false)
    const [nameError, setNameError] = useState(false)
    const [revenueAccountError, setRevenueAccountError] = useState(false)
    const [inventoryAccountError, setInventoryAccountError] = useState(false)

    const [isGoods, setIsGoods] = useState(false);
    const [productOptions, setProductOptions] = useState([{}]);

    // const [hasVariants, setHasVariants] = useState(false);
    // const handleChange = (event) => {
    //     setHasVariants(event.target.checked);
    //     console.log(event.target.checked)
    // };

    const getDefaultValues = () => {
        setSku(item.sku)
        setName(item.name)
        setInventoryType(item.type)
        setType(item.type)
        // setCostInput(item.cost)
        setQuantity(item.quantity)
        setReorderLevel(item.reorder_level)
        setExpenseAccount(item.expense_account)
        setInventoryAccount(item.inventory_account)
    }


    const mutation = useMutation({
        mutationFn: (item) => {
            return authAxios.put(`/inventory/items/${params.id}/`, item);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (data, variables, context) => {
            // queryClient.invalidateQueries(['item', 'items']);
            queryClient.invalidateQueries({ queryKey: ['item', 'items'] });
            queryClient.refetchQueries(['item']);
            navigate('/dashboard/items/');
        },
      })

    const handleSubmit = (e) => {
        e.preventDefault();

        if (name === '') {
            setNameError(true)
        }

        if (name ) {
            //Change the format of Price field before saving
            let price = 0
            // if (rate){
            //     price = parseFloat(rate.replace(/,/g, ''));
            // }

            let cost = 0
            if (costInput !== null) {
                cost = parseFloat(costInput.replace(/,/g, ''));
            }

            const expense_account = expenseAccount
            const inventory_account = inventoryAccount
            // const inventory_type = inventoryType
            // const type = inventoryType
            const reorder_level = reorderLevel

            const item = { 
                // client, name, upc, unit, cost, type, inventory_type, reorder_level, memo, tax, expense_account, inventory_account, user, 
                client, name, cost, type, reorder_level, memo, user, 
            };
            console.log(item)
            mutation.mutate(item)
        } 
    }

    // DO NOT DELETE!!!
    // =======================
    // const EbayListItem = async () => {
    //     try {
    //         const response = await axios.post('/ebay/ebay-listing/', 
    //         {
    //             headers: {
    //             'X-EBAY-API-IAF-TOKEN': `Bearer ${ebayAccessToken}`,
    //             },
    //         },
    //         );
    //         console.log("RESPONSE",response.data)
    //     } catch (error) {
    //         if (error.response.status === 401) {
    //             console.log("API 401",error.response)
    //             refreshEbayToken();
    //         } else {
    //             console.error(error);
    //         }
    //     }
    // }


    return(
        <section className="dashboard-form">
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <div className="grouped-fields-light">
                    <TextField className="custom-input"
                        value={sku ?? ''}
                        label="SKU" 
                        inputProps={{readOnly: true}}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined" 
                        fullWidth
                        disabled
                    />

                    <TextField className="custom-input"
                        value={name ?? ''}
                        onChange={(e) => {
                            setNameError(false)
                            setName(e.target.value)
                        }}
                        label="Name" 
                        InputLabelProps={{ shrink: true }}
                        variant="outlined" 
                        fullWidth
                        required
                        error={nameError}
                        disabled
                    />

                    {/* {inventoryTypes && inventoryType &&

                    <Autocomplete
                        value={inventoryTypes.find(type => type.id === inventoryType) ?? ''}
                        onChange={(event, option) => {
                            setInventoryTypeError(false)
                            setInventoryType(option.id)
                        }}
                        options={inventoryTypes}
                        getOptionLabel={(option) => option.name ?? ''}
                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Inventory Type" />}
                    />
                    } */}
                </div>


                <div className="grouped-fields-light">

                    <NumberFormat 
                        value={costInput ?? ''}
                        onChange={(e) => {
                            setCostInput(e.target.value)
                        }}
                        className="custom-input"
                        fullWidth
                        label="Cost" 
                        variant="outlined" 
                        customInput={TextField}
                        thousandSeparator={true} 
                    />

                    <NumberFormat 
                        value={quantity}
                        className="custom-input"
                        fullWidth
                        label="Quantity" 
                        variant="outlined" 
                        customInput={TextField}
                        thousandSeparator={true} 
                        inputProps={{readOnly: true}}
                        // disabled
                    />

                    <NumberFormat 
                        value={reorderLevel ?? ''}
                        onChange={(e) => {
                            setReorderLevel(e.target.value)
                        }}
                        className="custom-input"
                        fullWidth
                        label="Reorder Level" 
                        variant="outlined" 
                        customInput={TextField}
                        thousandSeparator={true} 
                    />
                </div>
                
               
                {/* <div className="grouped-fields-light">
                    {inventoryAccounts && inventoryAccount &&
                    <Autocomplete
                        value={inventoryAccounts.find(account => account.id === inventoryAccount) ?? ''}
                        onChange={(event, option) => {
                            setInventoryAccount(option.id)
                        }}
                        options={inventoryAccounts}
                        getOptionLabel={(option) => option.name ?? ''}
                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Inventory Account" />}
                    />
                    }

                    {expAccounts && expenseAccount &&
                    <Autocomplete
                        value={expAccounts.find(account => account.id === expenseAccount) ?? ''}
                        onChange={(event, option) => {
                            setExpenseAccount(option.id)
                        }}
                        options={expAccounts}
                        getOptionLabel={(option) => option.name ?? ''}
                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Expense Account" />}
                    />  
                    }
                </div> */}
                
                <div className="grouped-fields-light">
                    <TextField className="custom-input"
                        value={memo}
                        onChange={(e) => {
                            setMemo(e.target.value)
                        }}
                        label="Notes"
                        variant="outlined"
                        multiline
                        rows={2}
                        fullWidth
                    />
                </div>

                {/* <div className="custom-switch-container custom-switch-container-white">
                    <CustomSwitch checked={checked} setChecked={setChecked}/>
                    <div className="custom-switch-label">
                        Variants
                    </div>
                </div> */}

                <div className="button-border-top button-group">
                    <button id="submit" className="btn btn-primary form-buttons" type="submit">
                        Save
                    </button>
                    {/* <Button variant="outlined" onClick={EbayListItem}>List on EBay</Button> */}
                </div>

            </form>

        </section>
     

    )
                    

}

export default ItemEdit;